<div class="logo-container">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.77023 0.543488H0.957041C0.428423 0.543488 0 0.97191 0 1.50053V5.31372C0 5.84234 0.428423 6.27076 0.957041 6.27076H4.77023C5.29885 6.27076 5.72727 5.84234 5.72727 5.31372V1.50053C5.72727 0.97191 5.29885 0.543488 4.77023 0.543488Z"
      class="logo-cell"
    />
    <path
      d="M12.4066 0.543488H8.5934C8.06479 0.543488 7.63636 0.97191 7.63636 1.50053V5.31372C7.63636 5.84234 8.06479 6.27076 8.5934 6.27076H12.4066C12.9352 6.27076 13.3636 5.84234 13.3636 5.31372V1.50053C13.3636 0.97191 12.9352 0.543488 12.4066 0.543488Z"
      class="logo-cell"
    />
    <path
      d="M20.043 0.543488H16.2298C15.7011 0.543488 15.2727 0.97191 15.2727 1.50053V5.31372C15.2727 5.84234 15.7011 6.27076 16.2298 6.27076H20.043C20.5716 6.27076 21 5.84234 21 5.31372V1.50053C21 0.97191 20.5716 0.543488 20.043 0.543488Z"
      class="logo-cell"
    />
    <path
      d="M4.77023 8.17985H0.957041C0.428423 8.17985 0 8.60827 0 9.13689V12.9501C0 13.4787 0.428423 13.9071 0.957041 13.9071H4.77023C5.29885 13.9071 5.72727 13.4787 5.72727 12.9501V9.13689C5.72727 8.60827 5.29885 8.17985 4.77023 8.17985Z"
      class="logo-cell"
    />
    <path
      d="M12.4066 8.17985H8.5934C8.06479 8.17985 7.63636 8.60827 7.63636 9.13689V12.9501C7.63636 13.4787 8.06479 13.9071 8.5934 13.9071H12.4066C12.9352 13.9071 13.3636 13.4787 13.3636 12.9501V9.13689C13.3636 8.60827 12.9352 8.17985 12.4066 8.17985Z"
      class="logo-cell"
    />
    <path
      d="M20.043 8.17985H16.2298C15.7011 8.17985 15.2727 8.60827 15.2727 9.13689V12.9501C15.2727 13.4787 15.7011 13.9071 16.2298 13.9071H20.043C20.5716 13.9071 21 13.4787 21 12.9501V9.13689C21 8.60827 20.5716 8.17985 20.043 8.17985Z"
      class="logo-cell"
    />
    <path
      d="M4.77023 15.8162H0.957041C0.428423 15.8162 0 16.2446 0 16.7733V20.5864C0 21.1151 0.428423 21.5435 0.957041 21.5435H4.77023C5.29885 21.5435 5.72727 21.1151 5.72727 20.5864V16.7733C5.72727 16.2446 5.29885 15.8162 4.77023 15.8162Z"
      class="logo-cell"
    />
    <path
      d="M12.4066 15.8162H8.5934C8.06479 15.8162 7.63636 16.2446 7.63636 16.7733V20.5864C7.63636 21.1151 8.06479 21.5435 8.5934 21.5435H12.4066C12.9352 21.5435 13.3636 21.1151 13.3636 20.5864V16.7733C13.3636 16.2446 12.9352 15.8162 12.4066 15.8162Z"
      class="logo-cell"
    />
    <path
      d="M20.043 15.8162H16.2298C15.7011 15.8162 15.2727 16.2446 15.2727 16.7733V20.5864C15.2727 21.1151 15.7011 21.5435 16.2298 21.5435H20.043C20.5716 21.5435 21 21.1151 21 20.5864V16.7733C21 16.2446 20.5716 15.8162 20.043 15.8162Z"
      class="logo-cell"
    />
  </svg>
</div>

<style lang="scss">
  .logo-container {
    display: inline-block;
    cursor: pointer;
  }

  :global(.logo-cell) {
    fill: black;
    transition: fill 0.2s ease;
  }

  .logo-container:hover :global(.logo-cell) {
    fill: #666666;
  }
</style>
